import _ from 'lodash';
import { mapGetters } from 'vuex';
import EffectivePlugins from '@/ltnplugins/EffectivePlugins';

export default {
  computed: {
    ...mapGetters('plugins', {
      siteDesignation: 'siteDesignation',
    }),
    // hierarchal plugin overrides will be done here in the mixin
    currentActivePlugins() {
      return EffectivePlugins.assemble(this.siteDesignation);
    },
    // hierarchal resolving values will be done here in the mixin
    isLoadboardEnabled() {
      const site = this.currentActivePlugins.loadboard;

      return site.enabled;
    },
    isLoadboardBiddingEnabled() {
      const site = this.currentActivePlugins.loadboard;

      return site.enabled && site.enableBidding;
    },
    unitsOfMeasure() {
      return this.currentActivePlugins.locality.units_of_measure;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/pluginMixin.js